import ObjectKeysConverter from '@/utils/caseConverter/objectKeys'
import CaseConverter from '@/utils/caseConverter'

const mapFulfillmentCenterFromApi = ({ Id: id, Name: name }) => ({ id, name })

const mapFulfillmentCentersFromApi = (fulfillmentCenters) => {
  return fulfillmentCenters.map(mapFulfillmentCenterFromApi)
}

const mapFulfillmentCenterToApi = ({ id: Id, name: Name }) => ({ Id, Name })

const mapFulfillmentCenterWithTypeFromApi = (fulfillmentCentersList) => {
  return { fcList: fulfillmentCentersList.map(fc => ({
      name: fc.fulfillment_center_name,
      id: fc.fulfillment_center_id,
      type: fc.fulfillment_center_type
    }))
  }
}

const mapFulfillmentCenterInformationFromApi = ({
  sendInventoryPageNotice
}) => ({
  sendInventoryPageNotice
})

export const mapFulfillmentCenterDetailsFromApi = ({
  id,
  name,
  timezone,
  streetAddress1,
  streetAddress2,
  city,
  state,
  country,
  zipCode,
  phone,
  email,
  information,
  fulfillmentCenterTypeId
}) => ({
  id,
  name,
  timezone,
  streetAddress1,
  streetAddress2,
  city,
  state,
  country,
  zipCode,
  phone,
  email,
  // eslint-disable-next-line no-mixed-operators
  information: information && mapFulfillmentCenterInformationFromApi(information) || {},
  type: fulfillmentCenterTypeId
})

export const mapLocationsFromApi = res => ObjectKeysConverter(({ locations: res }), CaseConverter.toCamel, true)

export const mapFulFillmentRulesFromApi = res => ObjectKeysConverter(({ rules: res.user_fc_configs, regions: res.regions }), CaseConverter.toCamel, true)

const mapGlobalRegionFromApi = (region) => ({
  name: region.name,
  id: region.id
})

const mapGlobalRegionsFromApi = (globalRegions) => ({ regions: globalRegions.map(mapGlobalRegionFromApi) })

const mapCountriesFromApi = (country) => ({
  id: country.id,
  name: country.name,
  code: country.code
})

const mapCountriesByRegionFromApi = (res) => (res.map(mapCountriesFromApi))

const mapLocationShippableToCountriesFromApi = (location) => ({
  id: location.id,
  name: location.name
})

const mapLocationsShippableToCountriesFromApi = (res) => (res.map(mapLocationShippableToCountriesFromApi))

export {
  mapFulfillmentCentersFromApi,
  mapFulfillmentCenterFromApi,
  mapFulfillmentCenterToApi,
  mapCountriesByRegionFromApi,
  mapGlobalRegionsFromApi,
  mapLocationsShippableToCountriesFromApi,
  mapFulfillmentCenterWithTypeFromApi
}
